// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__22Mkg","social_links":"Footer_social_links__1Jddt","linkstyle":"Footer_linkstyle__jmts9","copyright":"Footer_copyright__xQ23B"};